import { routerReducer as routing } from 'react-router-redux';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import account from '../../features/account/redux/reducer';
import dashboardStorage from '../../features/dashboardStorage/redux/reducer';
import manageStorage from '../../features/manageStorage/redux/reducer';
import manageUser from '../../features/manageUser/redux/reducer';

const accountPersistConfig = {
  key: 'account',
  storage: storage,
  whitelist: ['isLoggedIn', 'account', 'sendOTPRemain', 'getOTPRemain'],
};

export default combineReducers({
  routing,
  account: persistReducer(accountPersistConfig, account),
  dashboardStorage,
  manageUser,
  manageStorage,
});






